module.exports = __webpack_public_path__ + "static/media/11_omh_omega.b3890a6a.svg";